import RewardsV2Shelf, { REWARDS_V2_SHELF_TYPES, DASHBOARD_V2_SHELF_TYPES } from './RewardsV2Shelf';

export default RewardsV2Shelf;
export { REWARDS_V2_SHELF_TYPES };
export { DASHBOARD_V2_SHELF_TYPES };
